import { Document } from "../../models";
import Mime from 'mime'

const getFileMimeType = (file: string): string | null => {
    const parts = file.split('.')
    return Mime.getType(parts[parts.length - 1])
}

export const __getPreviewImageFromAttachments = (getFileMimeType: (file: string) => string | null) => (document: Document): string | null => {
    const images = document.attachments.filter(x => {
        if(!x.fileUid) return false;
        const mimeType = getFileMimeType(x.fileUid)
        if (mimeType) {
            return mimeType.startsWith('image')
        }
        return false
    })

    return images.length ? images[0].fileUid : null
}

export const getPreviewImageFromAttachments = __getPreviewImageFromAttachments(getFileMimeType)